import { useRef, useEffect } from 'react';
import { select } from 'd3';

/**
 * Hook for selecting a d3 element via hooks.
 *
 * NOTE: We specifically do _not_ use a deconstructor in `useEffect`
 * because that prevents d3 from inserting / appending nodes correctly.
 * @param {Function} fn Function that accepts a d3 selection
 * @param {Array} deps Array of dependencies to listen on
 * @returns {Ref} React reference to the d3 node
 */
function useD3(fn, deps) {
  const ref = useRef();

  useEffect(() => {
    fn(select(ref.current));
  }, deps);

  return ref;
}

export default useD3;
export { useD3 };
